// @flow

import A from '../../actions/actionTypes';
import uniq from '../../utils/uniq';
import dataReducerGenerator from './dataReducerGenerator';
import { post } from './basicElements';

function toggleRate(state, action) {
  const id = action.rate.id;
  const oldPost = state[id] || {};
  const hasRated = oldPost.hasRated;

  return {
    [id]: {
      ...oldPost,
      hasRated: !hasRated,
      numRatings: (oldPost.numRatings || 0) + (hasRated ? -1 : 1),
    },
  };
}

function deletePost(postId, state) {
  const newState = { ...state };
  delete newState[postId];

  return newState;
}

function modifyResponse(response: any, state: any, add: bool = true) {
  if (response.isTemporary || response.parent === undefined || response.parent === response.id) {
    return state;
  }

  const id = response.parent;
  const parent = state[id];
  const prevResponses = parent.responses || [];
  const responses = add ?
    uniq([...prevResponses, response.id]) :
    prevResponses.filter(rId => rId !== response.id);
  let diff = responses.length - prevResponses.length;

  if (diff === 0) return state;
  diff = diff * (1 + (response.totalResponses || 0));

  const newState = { ...state, [id]: { ...parent, responses } };
  let post = newState[id];
  while (!!post && !!post.id) {
    newState[post.id] = { ...post, totalResponses: post.totalResponses + diff };
    post = newState[post.parent];
  }

  return newState;
}

export default (assign: any) => {
  const defaultPostReducer = dataReducerGenerator('posts', post, assign);

  return (oldState: any = {}, action: any) => {
    let state = oldState;
    const postToDelete = action.dataToDelete && action.dataToDelete.posts;

    if (postToDelete) {
      state = postToDelete
        .reduce((s, response) => modifyResponse(response, s, false), state);
    }

    switch (action.type) {
      case A.POST_TOGGLE_RATE:
      case A.POST_TOGGLE_RATE_FAILURE:
        return Object.assign({}, state, toggleRate(state, action));
      case A.POST_DELETE:
        return deletePost(action.postId, state);
      case A.POST_DELETE_FAILURE:
      case A.POST_RESPOND_SUCCESS:
        state = Object.values(action.data.posts)
          .reduce((s, response) => modifyResponse(response, s), state);
        return defaultPostReducer(state, action);
      default:
        return defaultPostReducer(state, action);
    }
  };
};



// WEBPACK FOOTER //
// ./~/virgo/src/reducers/data/posts.js